import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {CompanyUser} from "../types/CompanyUser";

export const useCompanyUsers = (dealerId: number) => {
    const { data, isLoading } = useQuery({
        queryKey: ['ee-tool-company-user', dealerId],
        queryFn: async () => await apiClient.get('ee-tool/company-users?dealerID=' + dealerId) as CompanyUser[],
        enabled: dealerId > 0,
        staleTime: 5 * 60 * 1000
    });

    return {
        data: data || [] as CompanyUser[],
        isLoading: isLoading
    };
};
